<!-- src\ui\components\FaInput\index.vue -->
<script setup lang="ts" generic="T extends string | number">
import type { InputHTMLAttributes } from 'vue'
import { cn } from '@/utils'
import { Eye, EyeOff } from 'lucide-vue-next'
import { ref } from 'vue'
import { Input } from './input'

defineOptions({
  name: 'FaInput',
})

const props = defineProps<{
  disabled?: boolean
  class?: InputHTMLAttributes['class']
  type?: InputHTMLAttributes['type']
  placeholder?: string
}>()

const value = defineModel<T>()
const showPassword = ref(false)

function togglePasswordVisibility() {
  if (props.disabled) {
    return false
  }
  showPassword.value = !showPassword.value
}
</script>

<template>
  <span class="relative">
    <Input
      v-model="value"
      :type="type === 'password' ? (showPassword ? 'text' : 'password') : type"
      :disabled="disabled"
      autocomplete="off"
      :class="cn(type === 'password' ? 'w-[200px] pr-6' : 'w-[200px]', props.class)"
      :placeholder="props.placeholder"
    />
    <button
      v-if="type === 'password'"
      type="button"
      class="absolute right-2 top-1/2 bg-transparent text-muted-foreground transition-colors -translate-y-1/2 hover:text-primary"
      :class="{ 'cursor-not-allowed opacity-50': disabled }"
      :disabled="disabled"
      @click="togglePasswordVisibility"
    >
      <EyeOff
        v-if="showPassword"
        class="h-4 w-4"
      />
      <Eye
        v-else
        class="h-4 w-4"
      />
    </button>
  </span>
</template>

<style scoped>
input[type="password"]::-ms-reveal {
  display: none;
}
</style>
